/**
 * Parses a string value - PRESERVES RAW DATA
 * @param val - The value to parse
 * @returns Parsed string or null (RAW, unsanitized)
 */
export const parseString = (val: any): string | null => {
  if (val == null) {
    return null;
  }

  let stringValue: string;

  if (typeof val === 'string') {
    stringValue = val;
  } else if (val.toString) {
    stringValue = val.toString();
  } else {
    stringValue = `${val}`;
  }
  return stringValue;
};
